import routes from '../core/constants/routes'
import { WORKFLOW_DOCTYPE } from '../core/constants/workflow.constant'

/**
 * Helpers for opening the documents behind a workflow (Vehicles) card.
 *
 * The board tags each card with a docType of 'estimate' | 'work order' | 'invoice'; the
 * client-portal-api related-documents endpoint speaks 'estimate' | 'workOrder' | 'invoice'
 * and answers with documents typed 'adasReport' | 'estimate' | 'workOrder' | 'invoice'.
 */

export const RELATED_DOC_TYPE = {
  ADAS_REPORT: 'adasReport',
  ESTIMATE: 'estimate',
  WORK_ORDER: 'workOrder',
  INVOICE: 'invoice',
}

const BOARD_TO_API_DOC_TYPE = {
  [WORKFLOW_DOCTYPE.ESTIMATE]: RELATED_DOC_TYPE.ESTIMATE,
  [WORKFLOW_DOCTYPE.WORK_ORDER]: RELATED_DOC_TYPE.WORK_ORDER,
  [WORKFLOW_DOCTYPE.INVOICE]: RELATED_DOC_TYPE.INVOICE,
}

const DETAIL_ROUTES = {
  [RELATED_DOC_TYPE.ADAS_REPORT]: [routes.ADAS_REPORT_DETAIL, ':id'],
  [RELATED_DOC_TYPE.ESTIMATE]: [routes.ESTIMATESDETAIL, ':id'],
  [RELATED_DOC_TYPE.WORK_ORDER]: [routes.WORKORDERDETAIL, ':workOrderId'],
  [RELATED_DOC_TYPE.INVOICE]: [routes.INVOICEDETAIL, ':invoiceId'],
}

// Board docType ('work order') -> API docType ('workOrder'); null when unknown.
export const toApiDocType = (boardDocType) => BOARD_TO_API_DOC_TYPE[boardDocType] || null

// Detail page for a related document; null when the type or id is missing/unknown.
export const getDocumentRoute = (document) => {
  if (!document || !document.id) return null
  const entry = DETAIL_ROUTES[document.type]
  if (!entry) return null
  const [path, param] = entry
  return path.replace(param, encodeURIComponent(document.id))
}

/**
 * Drop entries the user cannot open: unknown types, and ADAS reports when the client may not
 * view them (the API already applies the per-client allowView gate; this mirrors App.js).
 */
export const visibleDocuments = (documents, canViewAdas) => (documents || []).filter((doc) => {
  if (!getDocumentRoute(doc)) return false
  if (doc.type === RELATED_DOC_TYPE.ADAS_REPORT && !canViewAdas) return false
  return true
})

/**
 * What a card click should do with the documents it resolved to:
 *   one document  -> { action: 'navigate', route }
 *   several       -> { action: 'choose', documents }
 *   none          -> { action: 'none' }
 */
export const resolveDocumentAction = (documents, canViewAdas) => {
  const visible = visibleDocuments(documents, canViewAdas)
  if (!visible.length) return { action: 'none' }
  if (visible.length === 1) return { action: 'navigate', route: getDocumentRoute(visible[0]) }
  return { action: 'choose', documents: visible }
}
